<div class="title-bar">
  <div
    class="title"
    [class.expanded]="expanded"
    [class.expandable]="!!menuItems?.length"
    [ngClass]="!!menuItems?.length ? 'expandable' : 'not-expandable'"
    (click)="!!menuItems?.length && (expanded = !expanded)"
    >
    {{ title }}
    @if (!!menuItems?.length) {
      <i class="material-icons rotated-down" [class.rotated-up]="expanded">play_arrow</i>
    }
  </div>
  @if (!!menuItems?.length && expanded) {
    <div class="menu-panel">
      @for (item of menuItems; track item) {
        <div class="menu-item title" (click)="onMenuItemClick(item)">
          {{ item.title }}
        </div>
      }
    </div>
  }
</div>
